export enum VehicleReason {
    VEHICLE_CREATED,
    VEHICLE_DATA_COMPLETED,
    RETRY_ENROLLMENT_WITH_ACCOUNT_SETUP_INCOMPLETE,
    RETRY_ENROLLMENT_WITH_ACCOUNT_SETUP_COMPLETE,
    FIRST_ENROLLMENT,
    FIRST_ENROLLMENT_ON_ACCOUNT_COMPLETED,
    REENROLLMENT_IN_WINDOW,
    REENROLLMENT_OUT_OF_WINDOW,
    REENROLLMENT_PERIOD_EXPIRED,
    RUC_APPROVED,
    RUC_DENIED,
    RUC_DENIED_RETRYABLE,
    RUC_ADMIN_DENIED_RETRYABLE,
    USER_REQUESTED,
    UNCOLLECTIBLE,
    NON_COMPLIANT,
    DEACTIVATE_PENDING_VEHICLE,
    RUC_DEACTIVATION_REQUESTED
}
